/**
 * mwApp.auth module <br>
 * Authentication, login, restore lost password
 *
 * @namespace mwApp/auth
 */

import { AuthSvc, E401Svc } from './auth.service'
import { access, compareTo, featureFlags, passwordValidator } from './auth.directives'
import ChangePasswordCtrl from './changePassword.controller'
import LoginCtrl from './login.controller'
import SetplexLoginCtrl from './setplex-login.controller'
import LostPasswordCtrl from './lostpassword.controller'
import TermsCtrl from './terms.controller'
import accessParserFactory from './accessParser.factory'
import authConfig from './auth.config'
import FeedbackCtrl from './feedback.controller'
import FeatureFlagsParserFactory from './featureFlagsParser.factory'
import PasswordResetCtrl from './passwordreset.controller'
import { KeycloakAdapterSvc } from './keycloak-adapter.service'

export default
angular.module('mwApp.auth', [])
  .config(authConfig)
  .directive('compareTo', compareTo)
  .directive('passwordValidator', passwordValidator)
  .directive('access', access)
  .directive('featureFlags', featureFlags)
  .service('e401Svc', E401Svc)
  .service('authSvc', AuthSvc)
  .service('keycloakAdapterSvc', KeycloakAdapterSvc)
  .controller('ChangePasswordCtrl', ChangePasswordCtrl)
  .controller('LoginCtrl', LoginCtrl)
  .controller('SetplexLoginCtrl', SetplexLoginCtrl)
  .controller('LostPasswordCtrl', LostPasswordCtrl)
  .controller('PasswordResetCtrl', PasswordResetCtrl)
  .controller('TermsCtrl', TermsCtrl)
  .controller('FeedbackCtrl', FeedbackCtrl)
  .factory('accessParser', accessParserFactory)
  .factory('featureFlagsParser', FeatureFlagsParserFactory)
